import React, { Fragment, useEffect, useRef, useState, createRef, useCallback } from 'react';
import {
    useRefresh,
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    EditController,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceField,
    ReferenceInput,
    TopToolbar,
    FileField,
    UrlField,
    DateField,
    WithRecord,
    useRecordContext,
} from 'react-admin';

import { Button, Box, Grid, Card } from '@mui/material';
import { Link, useParams } from 'react-router-dom'

import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { ruleList } from '../editor/RuleStatic';
import BlockCopyDialog from './BlockCopyDialog';
import client from '../common/client';
import {getLoginToken, getSelectedProject} from '../common/common.js'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import BlockEditor from '../editor/BlockEditor';

const BlockFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="Block Name" source="name" alwaysOn />
    </Filter>
);

export const BlockList = props => {
    return (
        <List title="Block" {...props} filters={<BlockFilter />}
            exporter={false}
            filter={{project_id:getSelectedProject()}}
            perPage={100}>
            <Datagrid>
                <TextField label="ID" source="id" />
                <TextField label="Block Name" source="name" />
                <ReferenceField linkType='edit' label="Sketch" source="sketch_udid" reference="sketch" sortable={false}>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="Sketch Update" source="sketch_udid" reference="sketch" sortable={false}>
                    <DateField showTime={true} source="reg_date" />
                </ReferenceField>
                <FileField label="Sketch File" source="sketch_file" title="Download" />
                {/* <ReferenceField label="Recent Change" source="touch.member_no" reference="user" sortable={false}>
                    <TextField source="name" />
                </ReferenceField>
                <TextField label="Recent Change"  source="touch.ago" /> */}

                <ShowButton />
                <EditButton />
            </Datagrid>
        </List>
    )
};

const BlockTitle = ({ record }) => {
    return <span>Block {record ? `"${record.name}"` : ''}</span>;
};

const required = (message = 'Required') =>
    value => value ? undefined : message;
const maxLength = (max, message = 'Too Long') =>
    value => value && value.length > max ? message : undefined;
const validateRequireAndLength = [required(), maxLength(100)];

export const BlockCreate = props => (
    <Create title={<BlockTitle />} {...props} mutationMode='pessimistic'>
        <SimpleForm>
            <ReferenceInput linkType='show' label="Sketch" source="sketch_udid" reference="sketch" filter={{project_id:getSelectedProject()}}>
                <SelectInput optionText="name" />
            </ReferenceInput>

            <TextInput resettable label="Block Name" source="name" validate={validateRequireAndLength} />
        </SimpleForm>
    </Create>
);



const PostEditActions = (props) => {
    const record = useRecordContext()
    const refresh = useRefresh()
    return (
        <TopToolbar>
            {/* <ShowButton basePath={basePath} record={data} /> */}
            {record && record.screen_list && record.screen_list.map(s => (
                <Box key={s.id}><Button startIcon={<ArrowUpwardIcon />} variant="outlined" color="secondary" component={Link}
                    to={{ pathname: `/screen/${s.id}`, }}>{s.name}</Button>&nbsp;</Box>
            ))}
            <Button variant="outlined" color="primary" >Copy Block ID</Button>
            &nbsp;
            <Button variant="outlined" color="primary" component={Link} to={{ pathname: `/cloud_html_json/${record && record.id}`, }}>Html Json</Button>
            &nbsp;
            <Button variant="outlined" color="primary" component={Link} to={{ pathname: `/cloud_json/${record && record.id}`, }}>Cloud Json</Button>
            &nbsp;
            <Button variant="outlined" color="primary" component={Link} to={{ pathname: `/sketch_block_json/${record && record.id}`, }}>Sketch Json</Button>
            &nbsp;
            <BlockCopyDialog block_id={record && record.id} onComplete={e => { refresh() }} />
        </TopToolbar>
    )
};


export const BlockEdit = props => {
    const [type, setType] = React.useState('targetComponent')
    const [rule, setRule] = React.useState(ruleList[0])
    const [ruleMore, setRuleMore] = React.useState(false)
    const [ruleInstance, setRuleInstance] = React.useState(null)
    const [ruleInstanceList, setRuleInstanceList] = React.useState([])
    const [ruleInstanceShowList, setRuleInstanceShowList] = React.useState([])
    const [targetNode, setTargetNode] = React.useState(null)
    const [change, setChange] = React.useState(1)

    const handleType = (event, newType) => {
        if (!newType || newType == type)
            return
        setType(newType);
        let rule = ruleList.filter(m => m.type == newType)[0]
        setRule(rule)

        if (newType == 'targetComponent')
            setRuleInstanceShowList(ruleInstanceList)
        else
            setRuleInstanceShowList(ruleInstanceList.filter(m => m.type == newType))

        setRuleInstance(null)
    };

    const updateRule = () => {
        if (props.id) {
            setChange(change + 1)
            client.request_get(`/api/rule/list/${props.id}`).then(ruleInstanceList => {
                setRuleInstanceList(ruleInstanceList)
                if (type == 'targetComponent')
                    setRuleInstanceShowList(ruleInstanceList)
                else
                    setRuleInstanceShowList(ruleInstanceList.filter(m => m.type == type))

                let targetComponent = ruleInstanceList.filter(m => m.type == 'targetComponent')
                if (targetComponent.length > 0) {
                    setTargetNode(targetComponent[0].select1)
                }
            })
        }
    }
    const handleEdit = (row) => {
        setRule(ruleList.filter(m => m.type == row.type)[0])
        setType(row.type)
        setRuleInstance(row)
    }

    useEffect(() => {
        updateRule();
    }, [])

    return (
        <Edit title={<BlockTitle />} {...props} mutationMode='pessimistic' actions={<PostEditActions />}>
            <SimpleForm >
                <ReferenceInput linkType='show' label="Sketch" source="sketch_udid" reference="sketch" filter={{project_id:getSelectedProject()}}>
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <TextInput resettable label="Block Name" source="name" validate={validateRequireAndLength} />

                <BooleanInput label="Fit to screen" source="fit_to_screen" />

                <WithRecord render={record => <BlockEditor id={record.id} />} />

            </SimpleForm>
        </Edit>
    )
};


export const BlockShow = ({ ...props }) => (
    <ShowView {...props} title={<BlockTitle />}>
        <SimpleShowLayout>
            <TextField label="Node Name" source="name" />

        </SimpleShowLayout>
    </ShowView>
);
